import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import TableActiveRepository from '../Repositories/IndexTableRepository'


class TableActiveBloc {

    channel = new Subject();
    repository = new TableActiveRepository()

    constructor() {
        this.channel.next({status: apiResponse.INITIAL})
    }

    fetchData = async (query, cancelToken) => {
        this.channel.next({status: apiResponse.LOADING})
        await this.repository.fetchTableActive(query, cancelToken).then((result) => {
            this.channel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.channel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default TableActiveBloc